import React from 'react';

import NextImage from 'next/image';

import { Container } from '../../../../components/Container/Container';
import { Heading } from '../../../../components/Heading/Heading';
import { Text } from '../../../../components/Text/Text';
import { useIsDesktopDevice } from '../../../../helpers/hooks/useIsDesktopDevice';
import numberOne from '../../assets/EasyLaunchSection/1.svg';
import numberTwo from '../../assets/EasyLaunchSection/2.svg';
import numberThree from '../../assets/EasyLaunchSection/3.svg';
import numberFour from '../../assets/EasyLaunchSection/4.svg';
import { DESKTOP_NUMBER_IMAGE_SIZE, MOBILE_NUMBER_IMAGE_SIZE } from '../../constants/constants';

export const EasyLaunchSection = () => {
  const isDesktopDevice = useIsDesktopDevice();
  const imageSize = !isDesktopDevice ? MOBILE_NUMBER_IMAGE_SIZE : DESKTOP_NUMBER_IMAGE_SIZE;

  return (
    <Container className="my-md" data-testid="EasyLaunchSection">
      <Heading className="mb-3 md:mb-16 md:text-center" variant="xl">
        Easy to launch
      </Heading>

      <div className="flex flex-col md:flex-row md:justify-around">
        <div className="md:1/4 flex w-full items-center p-4 md:flex-col">
          <NextImage
            width={imageSize}
            height={imageSize}
            src={numberOne}
            alt="fish icon"
            className="mb-2"
          />
          <div className="ml-4 flex flex-col items-start md:ml-0 md:items-center">
            <Heading as="span" variant="sm" className="mb-0 md:mb-2">
              Confirm
            </Heading>
            <Text variant="md" className="md:text-center">
              Decide on a start date and budget
            </Text>
          </div>
        </div>
        <div className="md:1/4 flex w-full items-center p-4 md:flex-col">
          <NextImage
            width={imageSize}
            height={imageSize}
            src={numberTwo}
            alt="gear icon"
            className="mb-2"
          />
          <div className="ml-4 flex flex-col items-start md:ml-0 md:items-center">
            <Heading as="span" variant="sm" className="mb-0 md:mb-2">
              Creative
            </Heading>
            <Text variant="md" className="md:text-center">
              Send creative assets and destination links
            </Text>
          </div>
        </div>
        <div className="md:1/4 flex w-full items-center p-4 md:flex-col">
          <NextImage
            width={imageSize}
            height={imageSize}
            src={numberThree}
            alt="personal bests icon"
            className="mb-2"
          />
          <div className="ml-4 flex flex-col items-start md:ml-0 md:items-center">
            <Heading as="span" variant="sm" className="mb-0 md:mb-2">
              Kickoff
            </Heading>
            <Text variant="md" className="md:text-center">
              The campagin starts
            </Text>
          </div>
        </div>
        <div className="md:1/4 flex w-full items-center p-4 md:flex-col">
          <NextImage
            width={imageSize}
            height={imageSize}
            src={numberFour}
            alt="personal bests icon"
            className="mb-2"
          />
          <div className="ml-4 flex flex-col items-start md:ml-0 md:items-center">
            <Heading as="span" variant="sm" className="mb-0 md:mb-2">
              Results
            </Heading>
            <Text variant="md" className="md:text-center">
              When the campaign has ended, we share the results
            </Text>
          </div>
        </div>
      </div>
    </Container>
  );
};
